var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
var DividerRoot = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    --divider__height: auto;\n    --divider__text-color: var(--container-border-color-400);\n    --divider__border-color: var(--container-border-color-300);\n\n    margin: 0;\n    flex-shrink: 0;\n    border-width: 0;\n    border-style: solid;\n    border-color: var(--divider__border-color);\n    border-bottom-width: thin;\n    height: var(--divider__height);\n    color: var(--divider__text-color);\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n"], ["\n    --divider__height: auto;\n    --divider__text-color: var(--container-border-color-400);\n    --divider__border-color: var(--container-border-color-300);\n\n    margin: 0;\n    flex-shrink: 0;\n    border-width: 0;\n    border-style: solid;\n    border-color: var(--divider__border-color);\n    border-bottom-width: thin;\n    height: var(--divider__height);\n    color: var(--divider__text-color);\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n"])), function (_a) {
    var orientation = _a.orientation;
    return orientation === 'vertical' && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            --divider__height: 100%;\n            border-bottom-width: 0;\n            border-right-width: 1px;\n        "], ["\n            --divider__height: 100%;\n            border-bottom-width: 0;\n            border-right-width: 1px;\n        "])));
}, function (_a) {
    var flexItem = _a.flexItem;
    return flexItem && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            align-self: stretch;\n            --divider__height: 'auto';\n        "], ["\n            align-self: stretch;\n            --divider__height: 'auto';\n        "])));
}, function (_a) {
    var hasChildren = _a.hasChildren;
    return hasChildren && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            display: flex;\n            white-space: nowrap;\n            text-align: center;\n            border: 0;\n\n            &::before,\n            &::after {\n                content: '';\n                align-self: center;\n            }\n        "], ["\n            display: flex;\n            white-space: nowrap;\n            text-align: center;\n            border: 0;\n\n            &::before,\n            &::after {\n                content: '';\n                align-self: center;\n            }\n        "])));
}, function (_a) {
    var hasChildren = _a.hasChildren, orientation = _a.orientation;
    return hasChildren &&
        orientation !== 'vertical' && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n            &::before,\n            &::after {\n                width: 100%;\n                border-top: 1px solid var(--divider__border-color);\n            }\n        "], ["\n            &::before,\n            &::after {\n                width: 100%;\n                border-top: 1px solid var(--divider__border-color);\n            }\n        "])));
}, function (_a) {
    var hasChildren = _a.hasChildren, orientation = _a.orientation;
    return hasChildren &&
        orientation === 'vertical' && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n            &::before,\n            &::after {\n                --divider__height: 100%;\n                border-left: 1px solid var(--divider__border-color);\n            }\n        "], ["\n            &::before,\n            &::after {\n                --divider__height: 100%;\n                border-left: 1px solid var(--divider__border-color);\n            }\n        "])));
}, function (_a) {
    var textAlign = _a.textAlign, orientation = _a.orientation;
    return textAlign === 'left' &&
        orientation !== 'vertical' && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n            &::before {\n                width: 10%;\n            }\n\n            &::after {\n                width: 90%;\n            }\n        "], ["\n            &::before {\n                width: 10%;\n            }\n\n            &::after {\n                width: 90%;\n            }\n        "])));
}, function (_a) {
    var textAlign = _a.textAlign, orientation = _a.orientation;
    return textAlign === 'right' &&
        orientation !== 'vertical' && css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n            &::before {\n                width: 90%;\n            }\n\n            &::after {\n                width: 10%;\n            }\n        "], ["\n            &::before {\n                width: 90%;\n            }\n\n            &::after {\n                width: 10%;\n            }\n        "])));
});
var DividerWrapper = styled.span(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    --divider__spacing: var(--space);\n\n    display: inline-block;\n    padding-left: var(--divider__spacing);\n    padding-right: var(--divider__spacing);\n\n    ", "\n"], ["\n    --divider__spacing: var(--space);\n\n    display: inline-block;\n    padding-left: var(--divider__spacing);\n    padding-right: var(--divider__spacing);\n\n    ", "\n"])), function (_a) {
    var orientation = _a.orientation;
    return orientation === 'vertical' && css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n            padding-top: var(--divider__spacing);\n            padding-bottom: var(--divider__spacing);\n        "], ["\n            padding-top: var(--divider__spacing);\n            padding-bottom: var(--divider__spacing);\n        "])));
});
/**
 * The Divider component provides a thin, unobtrusive line for grouping elements to reinforce visual hierarchy.
 * By default, renders a horizontal gray line, but can be customized to be vertical or have text.
 *
 * ## Usage
 *
 * ### Basic
 *
 * The default is a horizonal line with no text.
 *
 * @example
 * ```tsx
 * <Divider />
 * ```
 *
 * ### With Content
 *
 * You can add content to the divider by passing it as a child. The content will be surrounded by lines of the divider
 * with some margin around it. Be default, the content will be centered, but you can use the `textAlign` prop to align
 * it to the left or right.
 *
 * @example
 * ```tsx
 * // Default center alignment
 * <Divider>Center</Divider>
 *
 * // Align content to the right
 * <Divider textAlign="left">Left</Divider>
 *
 * // Align content to the right
 * <Divider textAlign="right">Right</Divider>
 * ```
 *
 * @example
 * ```tsx
 * <Spacer.Stacked space="md">
 *    <Divider>Title center</Divider>
 *    <Btn>Option 1</Btn>
 *    <Btn>Option 2</Btn>
 *
 *    <Divider textAlign="left">Title left</Divider>
 *    <Btn>Option 3</Btn>
 *    <Btn>Option 4</Btn>
 *
 *    <Divider textAlign="right">Title right</Divider>
 *    <Btn>Option 5</Btn>
 *    <Btn>Option 6</Btn>
 * </Spacer.Stacked>
 *```
 *
 * ### Vertical
 *
 * You can change the orientation of the divider to be vertical by passing the `orientation` prop.
 * This will render a vertical line with no text. This works well for separating content in a column layout.
 * If you are working in a flex environment, for example within a `<Spacer.Align>`, you should use
 * the `flexItem` prop to make the divider fill the available space.
 *
 * @example
 * ```tsx
 * <Divider orientation="vertical" />
 * ```
 *
 * @example
 * ```tsx
 * <Spacer.Align space="md">
 *    <Btn link><Icon name="FormatAlignLeft" /></Btn>
 *    <Btn link><Icon name="FormatAlignCenter" /></Btn>
 *    <Btn link><Icon name="FormatAlignRight" /></Btn>
 *    <Divider orientation="vertical" flexItem />
 *    <Btn link><Icon name="FormatAlignJustify" /></Btn>
 * </Spacer.Align>
 * ```
 */
export var Divider = function (props) {
    // Destruct the props with some sensible defaults
    var children = props.children, _a = props.flexItem, flexItem = _a === void 0 ? false : _a, _b = props.textAlign, textAlign = _b === void 0 ? 'center' : _b, _c = props.orientation, orientation = _c === void 0 ? 'horizontal' : _c;
    return (React.createElement(DividerRoot, { hasChildren: !!children, flexItem: flexItem, textAlign: textAlign, orientation: orientation }, children ? React.createElement(DividerWrapper, { orientation: orientation }, children) : null));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
